import React from 'react';
import CollectionPage from '../shared/CollectionPage';

/**
 * Console Wishlist Dashboard component
 * Uses the generic CollectionPage with console-specific configuration for wishlist
 */
const ConsoleWishlistDashboard = () => {
  // Console-specific filter options (by generation)
  const consoleFilterOptions = [
    { value: '1', label: '1st Generation' },
    { value: '2', label: '2nd Generation' },
    { value: '3', label: '3rd Generation' },
    { value: '4', label: '4th Generation' },
    { value: '5', label: '5th Generation' },
    { value: '6', label: '6th Generation' },
    { value: '7', label: '7th Generation' },
    { value: '8', label: '8th Generation' },
    { value: '9', label: '9th Generation' },
  ];

  // Console-specific render props
  const consoleRenderProps = {
    getImageUrl: (item) => item.imageUrl || item.processedImageUrl || item.platformLogo,
    getItemSubtitle: (item) => `Generation: ${item.generation || 'N/A'}`,
    getItemDetails: (item) => item.alternative_name ? `Alternative Name: ${item.alternative_name}` : null,
    isWishlist: true
  };

  // Console-specific filter function (by generation)
  const getConsoleFilterValue = (item) => item.generation ? item.generation.toString() : '';

  // Console-specific edit fields
  const consoleEditFields = [
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      gridProps: { xs: 12 }
    },
    {
      name: 'generation',
      label: 'Generation',
      type: 'select',
      options: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'priority',
      label: 'Priority',
      type: 'select',
      options: ['Low', 'Medium', 'High'],
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'alternative_name',
      label: 'Alternative Name',
      type: 'text',
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'imageUrl',
      label: 'Image URL',
      type: 'text',
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'platformLogo',
      label: 'Platform Logo URL',
      type: 'text',
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'rating',
      label: 'Rating',
      type: 'rating',
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'notes',
      label: 'Notes',
      type: 'text',
      multiline: true,
      rows: 4,
      required: false,
      gridProps: { xs: 12 }
    }
  ];

  return (
    <CollectionPage
      collectionType="console-wishlist"
      title="Console Wishlist"
      isWishlist={true}
      itemType="console"
      renderProps={consoleRenderProps}
      filterOptions={consoleFilterOptions}
      getFilterValue={getConsoleFilterValue}
      editFields={consoleEditFields}
    />
  );
};

export default ConsoleWishlistDashboard;
